import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PopUp from '../elements/PopUp';
import { CSSTransition } from 'react-transition-group';
import { __ } from 'i18n-for-browser';

/**
 * Import assets
 */
import VideoIcon from '../../assets/img/icons/play.svg';

export default class VideoButton extends Component {
  static propTypes = {
    elementFocus: PropTypes.string,
    popUpTitle: PropTypes.string,
    popUpDescription: PropTypes.string,
    buttonText: PropTypes.string,
    nextUpType: PropTypes.string,
  };
  static defaultProps = {
    nextUpType: 'close'
  };

  constructor(props) {
    super(props);
    this.state = {
      // To do, replace with function getting current round
      currentRound: 2,
      roundTitle: __("sim_hoe_staat_je_land_ervoor"),
      showPopUp: false,
    };
  }

  togglePopUp() {
    this.setState({
      showPopUp: !this.state.showPopUp
    });
    if (this.state.showPopUp) {
      if (this.props.elementFocus) {

      }
    }
  }

  render() {
    return (
      <div>
        <div className="question-mark video" onClick={this.togglePopUp.bind(this)}>
          <img alt="videoIcon" src={VideoIcon}/>
        </div>

        <CSSTransition
          in={this.state.showPopUp}
          timeout={200}
          classNames="animation"
          unmountOnExit>

          {state => (
            <PopUp
              title={this.props.popUpTitle}
              description={this.props.popUpDescription}
              nextUpType={this.props.nextUpType}
              buttonText={this.props.buttonText}
              showPopUp={this.state.showPopUp}
              elementFocus={this.props.elementFocus}
              closePopUpClick={this.togglePopUp.bind(this)}
              video={this.props.src}
              interactive
            />
          )}
        </CSSTransition>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/VideoButton.js